
import { defineComponent } from "vue";
import { useI18n } from "vue3-i18n";

export default defineComponent({
  name: "Navbar",
  setup() {
    const i18n = useI18n();
    const setLocale = (lang: string) => {
      i18n.setLocale(lang);
    };

    return {
      setLocale,
    };
  },
  data() {
    return {
      lang: "th",
    };
  },
  mounted() {
    // this.lang = window.localStorage.getItem("lang")==null?this.lang:window.localStorage.getItem("lang");
  },
  watch: {
    lang(value) {
      this.setLocale(value);
      this.$emit("changeLang", value);
    },
  },

  methods: {},
});
